
<template>
    <router-link class="quicklink__item" :to="{ name: 'area', params: { area: path } }">
        <span>{{ name }}</span>
        <div class="arrow"><SVGlink-arrow /></div>
    </router-link>
</template>

<script>
export default {
    props: {
        path: {
            type: String,
            required: true
        },
        name: {
            type: String,
            required: true
        }
    }
}
</script>

